import { useNavigate } from "react-router";

import { Chip, useTheme } from "@mui/material";
import { FarmChipIcon } from "components/Icons/Icons";
import { formatNumber } from "utility/formatters";

import { TilleyCard } from "../../../Cards/TilleyCard";
import { FarmVaultIcon } from "../../../Icons/Icons";

export default function FarmCountyCard({
  currentCounty,
  crop_year = "potential",

  isNavigation = true,
  icon = FarmVaultIcon,
}) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <TilleyCard
      sx={{ cursor: isNavigation ? "pointer" : "default" }}
      data-testid={`Open-${currentCounty?.location_county_name}-${currentCounty?.location_state_name}`}
      onClick={() =>
        isNavigation &&
        navigate(`/vault/${crop_year}/${currentCounty.location_state_name}/${currentCounty.location_county_name}`)
      }
      Avatar={icon}
      title={`${currentCounty?.location_county_name}, ${currentCounty?.location_state_name}`}
      details={[
        {
          value: formatNumber(currentCounty?.reported_acreage, 0),
          label: "ACRES",
        },
        {
          value: formatNumber(currentCounty?.base_acreage, 0),
          label: "BASE ACRES",
        },
      ]}
      footer={
        <Chip
          sx={{ "& .MuiChip-label": { fontWeight: 500 } }}
          icon={
            <FarmChipIcon
              sx={{
                width: "26px",
                height: "26px",
                color: `${theme.palette.grey.A100} !important`,
              }}
            />
          }
          color="default"
          label={
            formatNumber(currentCounty?.unit_count, 0) + " farm" + (Number(currentCounty?.unit_count) === 1 ? "" : "s")
          }
        />
      }
    />
  );
}
